<template>
    <div class="row" :style="rowStyle">
        <div class="col-12">
            <div class="row">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Select the data fields for your anonymized custom audience.</span>
                    </v-tooltip>

                    <i class="fas fa-table"></i> <span style="padding-left: 5px;"> Fields</span>
                </div>

                <div class="form-group col-md-2" v-for="field_item in anonymized_fields">
                    <template>
                        <v-container fluid>
                            <v-select
                                :value="$store.getters['CreateAudienceStore/getAnonymizedData']({
                                    dataset: dataSetOrder,
                                    item: field_item.field
                                })"
                                @input="commitFieldValueToStore($event, field_item.field)"
                                :items="$store.getters['CreateAudienceStore/getAnonymizedDataAll']({
                                        dataset: dataSetOrder,
                                        item: field_item.field
                                    })"
                                :label="field_item.label"
                                multiple
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('anonymized_fields_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('anonymized_fields_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text }}</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getAnonymizedData']({
                                            dataset: dataSetOrder,
                                            item: field_item.field
                                        }).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, field_item.field)"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getAnonymizedData']({
                                                dataset: dataSetOrder,
                                                item: field_item.field
                                            }).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, field_item.field) }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

            </div>

        </div>
    </div>
</template>

<script>
import analyses from "../../../../../mixin/analyses"
import {mapState} from "vuex";
import {identifier} from "@vue/test-utils";
export default {
    name: "AnonymizedFields",
    mixins: [analyses],
    props: [
        'dataSetOrder',
        'rowStyle',
        'analysisType'
    ],
    data: () => ({
        anonymized_fields: [
            {
                label: 'Geo-Location',
                field: 'geoLocation'
            },
            {
                label: 'Advertising',
                field: 'advertising'
            },
            {
                label: 'User Details',
                field: 'userDetails'
            },
            {
                label: 'IP Details',
                field: 'ipDetails'
            },
            {
                label: 'Privacy',
                field: 'privacy'
            }
        ]
    }),
    methods: {
        commitFieldValueToStore(event, field) {
            this.$store.commit('CreateAudienceStore/SET_DATASET_ANONYMIZED_DATA', {
                dataset: this.dataSetOrder,
                field: field,
                value: event
            })
        },
        toggleItems(dataset, data) {
            if (this.selectedAllItems(dataset, data)) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_ANONYMIZED_DATA', {
                    dataset: dataset,
                    field: data,
                    value: []
                })
            } else {
                let items = this.$store.getters['CreateAudienceStore/getAnonymizedDataAll']({
                    dataset: dataset,
                    item: data,
                }).map(a => {
                    return a.value
                })

                this.$store.commit('CreateAudienceStore/SET_DATASET_ANONYMIZED_DATA', {
                    dataset: dataset,
                    field: data,
                    value: items
                })
            }
        },
    },
    computed: {
        selectedAllItems() {
            return (dataset, data) => {
                return this.$store.getters['CreateAudienceStore/getAnonymizedData']({
                    dataset: dataset,
                    item: data
                }).length === this.$store.getters['CreateAudienceStore/getAnonymizedDataAll']({
                    dataset: dataset,
                    item: data
                }).length
            }
        },
        selectedSomeItems() {
            return (dataset, data) => {
                return this.$store.getters['CreateAudienceStore/getAnonymizedData']({
                    dataset: dataset,
                    item: data
                }).length > 0 && !this.selectedAllItems(dataset, data)
            }
        },
        showingIcon() {
            return (dataset, data) => {
                if (this.selectedAllItems(dataset, data)) return 'mdi-close-box'
                if (this.selectedSomeItems(dataset, data)) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            }
        },
    },
    mounted() {
        this.$store.dispatch('CreateAudienceStore/fetchAnonymizedFieldsData', this.dataSetOrder)
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>